import React from 'react';
import { useSelector } from 'react-redux';
import PhysicianCardView from 'src/common/components/PhysicianCardView/PhysicianCardView';
import AdditionalProcedureData from 'src/common/components/additionalProcedure/AdditionalProcedureData';
import DeformityCorrectionCard from 'src/common/components/deformityCorrection/DeformityCorrection';
import PhysicianFinderCard from 'src/common/components/physicianFinder/PhysicianFinderEligibility';
import BiologicsUsedCard from 'src/common/components/biologicsUsed/BiologicsUsedCard';
// import { TitleComponent } from '../../utils/reportUsage.styled';
import { reorderMazorX } from 'src/utils/util';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import ReportProcedureDataFooter from '../orderDetailFooter/ReportProcedureDataFooter';
import { Divider, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import {
    Header,
    ContentBody,
    HeaderContainer,
    DetailBody,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import {
    CloseIconContainer,
    CloseIcon,
} from 'src/pages/orders/components/orderDetails/orderDetailHeader/OrderDetailHeader.styled';
import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';
import Close from 'src/assets/images/ModalClose.svg';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import { sizes } from 'src/styles/Media.styled';
import { getProcedureInfoRequest } from 'src/pages/reportUsage/redux/action/actionCreators';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import RetractorUsedCard from 'src/common/components/retractorUsed/RetractorUsed';
import LevelProcedureCard from 'src/common/components/levelProcedure/LevelProcedure';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReportProcedureDataView = ({
    showReportProcedureModal,
    loading,
    kitCodeValidationInProgress,
    procedureInfoData,
    radioButtonChangeHandler,
    mazorxChecked,
    mazorRoboticsCode,
    setMazorCaseCoverageInputValue,
    mazorCaseCoverageInputValue,
    selectedMazorCaseCoverage,
    setSelectedMazorCaseCoverage,
    mazorCodeValidator,
    mazorCodeValidatorOnBlur,
    validateMazorCodeRes,
    checkboxSelectionChangeHandler,
    handleInputChange,
    retractorUsedOtherFieldValue,
    textAreaCharLimit,
    charCountLimit,
    setProcedureInfoData,
    showBiologisDetails,
    setDropDownValue,
    dropDownValue,
    selectedPhysicianData,
    setSelectedPhysicianData,
    setPhysicianInputValue,
    physicianInputValue,
    proceduresList,
    showProcedureDropdown,
    handleSubmitProcedure,
    isDisabled,
    closeReportProcedureDataView,
    advancedEnergyCheck,
    advanceEnergyProduct,
    reportProcedureMycaseRefId,
    reportUsageObject,
    procedureDataPhysicianVisibility,
    procedureMandatoryRule,
    isFromProcedure,
    isPediatricSurgery,
    setPediatricCheck,
    isDisabledPediatric,
    pediatricMandatoryRule,
    pediatricSurgeryVisibility,
    pediatricValue,
    //StealthAxis
    stealthAxisChecked,
    stealthAxisCode,
    setStealthAxisCode,
    stealthAxisAutoPilot,
    setStealthAxisAutoPilot,
    stealthAxisLiveAlign,
    setStealthAxisLiveAlign,
    setStealthAxisCaseCoverageInputValue,
    stealthAxisCaseCoverageInputValue,
    setSelectedStealthAxisCaseCoverage,
    selectedStealthAxisCaseCoverage,
    stealthCodeValidatorOnBlur,
    stealthAxisCodeError,
    setStealthAxisCodeError,
    equityStealthAutoPilotVisibility,
    equityStealthLiveAlignVisibility,
    physicianTextUsageVisibility,
    physicianTextUsageMandatory,
    physicianFieldText,
    setPhysicianFieldText,
    physicianTextBoxType,
    setPhysicianTextBoxType,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { myCaseRef, showBackButton } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const { levelsUsedEquity, userDetailsLoading } = useSelector(
        (state) => state.loginReducer
    );
    const { procedureDataLoading } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const { loading: submitProcedureLoading } = useSelector(
        (state) => state.submitProcedureDataReducer
    );
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const VALIDATION_MAZORX = '10723';
    const VALIDATION_DRAFT = 'draft';

    const data = {
        procedureCode: '',
        salesOrg: salesOrg,
    };
    useEffectWithErrorLogging(() => {
        dispatch(getProcedureInfoRequest('Equity', data));
    }, [myCaseRef, levelsUsedEquity, userDetailsLoading]);
    const showSection =
        showProcedureDropdown && procedureMandatoryRule
            ? !procedureInfoData?.procedureConfigFlag
            : true;
    const INITIAL_FIELD_ORDER =
        window.innerWidth <= sizes.mobileDevice
            ? [
                  'Powerease',
                  'Stealth S7/S8 Navigation',
                  'Stealth AXiS',
                  'Advanced Energy',
                  'MazorX Robot Used',
              ]
            : [
                  'Powerease',
                  'Advanced Energy',
                  'Stealth S7/S8 Navigation',
                  'MazorX Robot Used',
                  'Stealth AXiS',
              ];

    const FIELD_ORDER =
        window.innerWidth <= sizes.mobileDevice ||
        (winWidth >= sizes.smalDevice && winWidth <= sizes.mediumDevice)
            ? INITIAL_FIELD_ORDER
            : procedureInfoData?.additionalProcedure &&
              Object.keys(procedureInfoData?.additionalProcedure).length > 0 &&
              reorderMazorX(
                  INITIAL_FIELD_ORDER,
                  procedureInfoData?.additionalProcedure
              );
    return (
        <>
            {showReportProcedureModal ? (
                <ModalDialog
                    modalHeight={'calc(100vh - 110px)'}
                    ipadModalHeight={'calc(100vh - 185px)'}
                    modalWidth={'70%'}
                    smalModalWidth={'85%'}
                    left={'7%'}
                    right={'7%'}
                    top={'7%'}
                    bottom={'10%'}
                    padding={'0px'}
                    handleClose={closeReportProcedureDataView}
                    isIPadPotrait={true}
                    zIndex={2000}
                    marginTop={'7.5rem'}
                >
                    <ContentBody contentHeight={'calc(100% - 40px)'}>
                        <HeaderContainer
                            padding={'1rem 1rem 0rem'}
                            marginBottom={'6px'}
                            spaceBetween={
                                !showBackButton ? 'space-between' : 'flex-end'
                            }
                        >
                            {!showBackButton ? (
                                <BackButtonContainer
                                    id="orders-reportproceduredataview-back-button-container"
                                    onClick={closeReportProcedureDataView}
                                    margin={'0px'}
                                >
                                    <BackButtonIcon src={BackIcon} />
                                    <BackText
                                        style={{
                                            marginTop: isMobileView
                                                ? '1px'
                                                : '0px',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >{`${t(
                                        'equity.cart.setDetails.backto'
                                    )} ${myCaseRef}`}</BackText>
                                </BackButtonContainer>
                            ) : null}

                            {/* <CloseIconContainer>
                                <CloseIcon
                                    mobilePath={Close}
                                    show={true}
                                    onClick={closeReportProcedureDataView}
                                />
                            </CloseIconContainer> */}
                        </HeaderContainer>
                        <div>
                            {isMobileView && (
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        width: '92%',
                                        marginLeft: '19px',
                                        paddingBottom: '12px',
                                        paddingTop: '17px',
                                    }}
                                >
                                    <Divider />
                                </Grid>
                            )}
                        </div>
                        <div>
                            {isMobileView ? (
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        fontSize: '20px',
                                        color: '#130E4A',
                                        fontFamily: 'AvenirNextWorld Demi',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    {t('orders.orderSummaryTabs.procedureData')}
                                </Grid>
                            ) : (
                                <Header
                                    fontSize="16px"
                                    padding={'0px 28px'}
                                    mobilePadding={'0px 20px'}
                                    marginBottom={'8px'}
                                >
                                    {t('orders.orderSummaryTabs.procedureData')}
                                </Header>
                            )}
                        </div>

                        {procedureDataLoading || userDetailsLoading ? (
                            <Spinner
                                id="orders-reportProcedureDataView-reportProcedureDataView-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        ) : (
                            <DetailBody
                                detailBodyPadding={'0px 20px 100px 20px'}
                                overflowX={'hidden'}
                                pdfContainerHeight={loading ? '100%' : 'unset'}
                                scrollBarWidth={'8px'}
                                scrollBarBackgroundColor={'#888'}
                                scrollBarBorderRadius={'10px'}
                                mediumDeviceScrollBarDisplay={'block'}
                                className={'procedure-detail-wrapper'}
                            >
                                {procedureInfoData &&
                                    Object.keys(procedureInfoData).length >
                                        0 && (
                                        <>
                                            {showProcedureDropdown ||
                                            procedureDataPhysicianVisibility ||
                                            physicianTextUsageVisibility === 'VISIBLE' ? (
                                                <PhysicianCardView
                                                    isEquity={true}
                                                    showProcedureDropdown={
                                                        showProcedureDropdown
                                                    }
                                                    setDropDownValue={
                                                        setDropDownValue
                                                    }
                                                    dropDownValue={
                                                        dropDownValue
                                                    }
                                                    proceduresList={
                                                        proceduresList
                                                    }
                                                    setPhysicianInputValue={
                                                        setPhysicianInputValue
                                                    }
                                                    physicianInputValue={
                                                        physicianInputValue
                                                    }
                                                    selectedPhysicianData={
                                                        selectedPhysicianData
                                                    }
                                                    setSelectedPhysicianData={
                                                        setSelectedPhysicianData
                                                    }
                                                    zIndex={9999999}
                                                    equityPadding={
                                                        '20px 22px 33px 22px'
                                                    }
                                                    reportUsageObject={
                                                        reportUsageObject
                                                    }
                                                    procedureDataPhysicianVisibility={
                                                        procedureDataPhysicianVisibility
                                                    }
                                                    procedureMandatoryRule={
                                                        procedureMandatoryRule
                                                    }
                                                    isDisabledPediatric={
                                                        isDisabledPediatric
                                                    }
                                                    setPediatricCheck={
                                                        setPediatricCheck
                                                    }
                                                    isPediatricSurgery={
                                                        isPediatricSurgery
                                                    }
                                                    isFromEquity={true}
                                                    pediatricMandatoryRule={
                                                        pediatricMandatoryRule
                                                    }
                                                    pediatricSurgeryVisibility={
                                                        pediatricSurgeryVisibility
                                                    }
                                                    pediatricValue={
                                                        pediatricValue
                                                    }
                                                    physicianTextUsageVisibility={
                                                        physicianTextUsageVisibility
                                                    }
                                                    physicianTextUsageMandatory={
                                                        physicianTextUsageMandatory
                                                    }
                                                    physicianFieldText={
                                                        physicianFieldText
                                                    }
                                                    setPhysicianFieldText={
                                                        setPhysicianFieldText
                                                    }
                                                    physicianTextBoxType={
                                                        physicianTextBoxType
                                                    }
                                                    setPhysicianTextBoxType={
                                                        setPhysicianTextBoxType
                                                    }
                                                />
                                            ) : null}
                                            {procedureInfoData?.levels &&
                                                !(
                                                    procedureInfoData
                                                        .levels?.[0] ===
                                                    'ADDITIONAL_PROCEDURE_DATA'
                                                ) && (
                                                    <LevelProcedureCard
                                                        levelsData={
                                                            procedureInfoData.levels
                                                        }
                                                        procedureInfoData={
                                                            procedureInfoData
                                                        }
                                                        setProcedureInfoData={
                                                            setProcedureInfoData
                                                        }
                                                    />
                                                )}

                                            {showSection &&
                                                procedureInfoData?.additionalProcedure &&
                                                procedureInfoData
                                                    .additionalProcedure
                                                    .length > 0 &&
                                                procedureInfoData
                                                    .additionalProcedure?.[0] !==
                                                    'ADDITIONAL_PROCEDURE_DATA' && (
                                                    <AdditionalProcedureData
                                                        advancedEnergyCheck={
                                                            advancedEnergyCheck
                                                        }
                                                        advanceEnergyProduct={
                                                            advanceEnergyProduct
                                                        }
                                                        additionalProcedureData={
                                                            procedureInfoData?.additionalProcedure
                                                        }
                                                        radioButtonChangeHandler={
                                                            radioButtonChangeHandler
                                                        }
                                                        mazorxChecked={
                                                            mazorxChecked
                                                        }
                                                        mazorRoboticsCode={
                                                            mazorRoboticsCode
                                                        }
                                                        setProcedureInfoData={
                                                            setProcedureInfoData
                                                        }
                                                        setMazorCaseCoverageInputValue={
                                                            setMazorCaseCoverageInputValue
                                                        }
                                                        mazorCaseCoverageInputValue={
                                                            mazorCaseCoverageInputValue
                                                        }
                                                        setSelectedMazorCaseCoverage={
                                                            setSelectedMazorCaseCoverage
                                                        }
                                                        selectedMazorCaseCoverage={
                                                            selectedMazorCaseCoverage
                                                        }
                                                        mazorCodeValidator={
                                                            mazorCodeValidator
                                                        }
                                                        mazorCodeValidatorOnBlur={
                                                            mazorCodeValidatorOnBlur
                                                        }
                                                        validateMazorCodeRes={
                                                            validateMazorCodeRes
                                                        }
                                                        errorBorderColor={
                                                            validateMazorCodeRes &&
                                                            validateMazorCodeRes.statusCode !==
                                                                VALIDATION_MAZORX &&
                                                            validateMazorCodeRes.statusCode !==
                                                                VALIDATION_DRAFT &&
                                                            '2px solid #FACFD6'
                                                        }
                                                        imgRightToText={true}
                                                        isEquity={true}
                                                        checkboxSelectionChangeHandler={
                                                            checkboxSelectionChangeHandler
                                                        }
                                                        reportProcedureMycaseRefId={
                                                            reportProcedureMycaseRefId
                                                        }
                                                        stealthAxisChecked={
                                                            stealthAxisChecked
                                                        }
                                                        stealthAxisCode={
                                                            stealthAxisCode
                                                        }
                                                        setStealthAxisCode={
                                                            setStealthAxisCode
                                                        }
                                                        stealthAxisAutoPilot={
                                                            stealthAxisAutoPilot
                                                        }
                                                        setStealthAxisAutoPilot={
                                                            setStealthAxisAutoPilot
                                                        }
                                                        stealthAxisLiveAlign={
                                                            stealthAxisLiveAlign
                                                        }
                                                        setStealthAxisLiveAlign={
                                                            setStealthAxisLiveAlign
                                                        }
                                                        setStealthAxisCaseCoverageInputValue={
                                                            setStealthAxisCaseCoverageInputValue
                                                        }
                                                        stealthAxisCaseCoverageInputValue={
                                                            stealthAxisCaseCoverageInputValue
                                                        }
                                                        setSelectedStealthAxisCaseCoverage={
                                                            setSelectedStealthAxisCaseCoverage
                                                        }
                                                        selectedStealthAxisCaseCoverage={
                                                            selectedStealthAxisCaseCoverage
                                                        }
                                                        stealthCodeValidatorOnBlur={
                                                            stealthCodeValidatorOnBlur
                                                        }
                                                        stealthAxisCodeError={
                                                            stealthAxisCodeError
                                                        }
                                                        setStealthAxisCodeError={
                                                            setStealthAxisCodeError
                                                        }
                                                        FIELD_ORDER={
                                                            FIELD_ORDER
                                                        }
                                                        isFromEquity={true}
                                                        equityStealthAutoPilotVisibility={
                                                            equityStealthAutoPilotVisibility
                                                        }
                                                        equityStealthLiveAlignVisibility={
                                                            equityStealthLiveAlignVisibility
                                                        }
                                                    />
                                                )}
                                            {showSection &&
                                                procedureInfoData?.therapies &&
                                                !(
                                                    procedureInfoData
                                                        ?.therapies?.[0] ===
                                                    'ADDITIONAL_PROCEDURE_DATA'
                                                ) && (
                                                    <PhysicianFinderCard
                                                        physicianFinderTitle={
                                                            'Therapy Details'
                                                        }
                                                        physicianFinderData={
                                                            procedureInfoData.therapies
                                                        }
                                                        checkboxSelectionChangeHandler={
                                                            checkboxSelectionChangeHandler
                                                        }
                                                    />
                                                )}
                                            {showSection &&
                                                procedureInfoData?.retractors &&
                                                !(
                                                    procedureInfoData
                                                        ?.retractors?.[0] ===
                                                    'ADDITIONAL_PROCEDURE_DATA'
                                                ) && (
                                                    <RetractorUsedCard
                                                        retractorUsedData={
                                                            procedureInfoData.retractors
                                                        }
                                                        checkboxSelectionChangeHandler={
                                                            checkboxSelectionChangeHandler
                                                        }
                                                        handleInputChange={
                                                            handleInputChange
                                                        }
                                                        retractorUsedOtherFieldValue={
                                                            retractorUsedOtherFieldValue
                                                        }
                                                        textAreaCharLimit={
                                                            textAreaCharLimit
                                                        }
                                                        charCountLimit={
                                                            charCountLimit
                                                        }
                                                    />
                                                )}
                                            {showSection &&
                                                procedureInfoData?.technologies &&
                                                !(
                                                    procedureInfoData
                                                        ?.technologies?.[0] ===
                                                    'ADDITIONAL_PROCEDURE_DATA'
                                                ) && (
                                                    <DeformityCorrectionCard
                                                        deformityTechnologiesData={
                                                            procedureInfoData.technologies
                                                        }
                                                        radioButtonChangeHandler={
                                                            radioButtonChangeHandler
                                                        }
                                                    />
                                                )}
                                            {showSection &&
                                                procedureInfoData?.biologicsUsed &&
                                                !(
                                                    procedureInfoData
                                                        ?.biologicsUsed?.[0] ===
                                                    'ADDITIONAL_PROCEDURE_DATA'
                                                ) && (
                                                    <BiologicsUsedCard
                                                        isEquity={true}
                                                        biologicsUsedData={
                                                            procedureInfoData.biologicsUsed
                                                        }
                                                        biologicsDetailData={
                                                            procedureInfoData.biologicsDetail
                                                        }
                                                        showBiologisDetails={
                                                            showBiologisDetails
                                                        }
                                                        checkboxSelectionChangeHandler={
                                                            checkboxSelectionChangeHandler
                                                        }
                                                    />
                                                )}
                                        </>
                                    )}
                            </DetailBody>
                        )}
                    </ContentBody>
                    {kitCodeValidationInProgress && (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="orders-reportProcedureDataView-mazorValidation-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </Backdrop>
                    )}
                    {submitProcedureLoading && (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="orders-reportProcedureDataView-submitProcedure-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </Backdrop>
                    )}
                    <ReportProcedureDataFooter
                        handleSubmitProcedure={handleSubmitProcedure}
                        handleCancel={closeReportProcedureDataView}
                        isDisabled={isDisabled}
                    />
                </ModalDialog>
            ) : null}
        </>
    );
};

export default ReportProcedureDataView;

export const ProcedureContainer = styled.div`
    ${media.mobileDevice`
        margin-bottom : ${({ isNoUsageToReport, bannerHeight }) =>
            !isNoUsageToReport
                ? bannerHeight
                    ? `${bannerHeight}`
                    : '40%'
                : 'unset'};
    `};
`;
